<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row justify="center">
      <v-col sm="1" lg="2" class="hidden-xs-only" >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="regresar"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2" :loading="loadingForm">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Registrar Saber
            </p>
          </v-card-title>

          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="10" lg="8">
                <v-form ref="form" v-model="form">
                  <!-- Campo Saber -->
                  <v-textarea
                    outlined
                    label="Saber*"
                    v-model="saber"
                    :rules="saberReglas"
                  ></v-textarea>

                  <!-- Descripción -->
                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model="descripcion"
                  ></v-textarea>

                  <!-- Botón -->
                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="registrar"
                  >
                    Registrar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  components: { Alert },

  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    form: true,
    loadingForm: false,

    saber: "",
    saberReglas: [(v) => !!v || "El campo Saber es obligatorio"],

    descripcion: "",
  }),

  methods: {
    regresar() {
      this.$router.back();
    },
    registrar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const saber = {
          saber: this.saber.toLowerCase(),
          descripcion: this.descripcion,
          categoria_id: this.$route.params.idCategoria,
        };

        this.$store
          .dispatch("registrarSaber", saber)
          .then((response) => {
            this.loadingForm = false;

            if (response.status === "success") {
              this.$refs.form.reset();

              let message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
                this.$router.replace({ name: "campesena-saber-gestionar" });
              }, 2000);
            } else {
              this.alertType = "error--text";
              this.alertTitle = "Error";
              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
         }
    },
  },
};
</script>
